import { render, staticRenderFns } from "./BbsHead.vue?vue&type=template&id=ec08dcda&scoped=true"
import script from "./BbsHead.vue?vue&type=script&lang=js"
export * from "./BbsHead.vue?vue&type=script&lang=js"
import style0 from "./BbsHead.vue?vue&type=style&index=0&id=ec08dcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec08dcda",
  null
  
)

export default component.exports